import useLocalStorage from './useLocalStorage'

import en from '../translations/en.json'
import es from '../translations/es.json'
import fr from '../translations/fr.json'
import it from '../translations/it.json'

export default function useLang() {
  const route = useRoute()
  const { user } = useLocalStorage()

  const messages = {
    en,
    es,
    fr,
    it
  }

  const routeLocale = computed(() => route.query?.locale?.toString())
  const defaultLang = computed(() => {
    const useRouteLocale = routeLocale.value && Object.keys(messages).includes(routeLocale.value)
    if (useRouteLocale) {
      return routeLocale.value
    }
    return user.value?.language?.iso639_1 ?? 'fr'
  })

  return { defaultLang, messages }
}
